export default "__VITE_ASSET__h4kpH$kJ__"